export interface ComplianceInput {
	kycIsOutdated?: boolean;
	amlLegalReviewRequested?: boolean;
	amlLegalReviewOutdated?: boolean;
	amlKycRevalidationState?: string | null;
	pepAssetsOriginQuestionnaireRequired?: boolean;
	pepBankIdRequired?: boolean;
	customerBlockingReasons?: string[];
}

export type ActionFlag =
	| 'renew_identity_verification'
	| 'complete_aml_review'
	| 'complete_pep_questionnaire'
	| 'account_blocked';

export const ACTION_FLAGS: readonly ActionFlag[] = [
	'renew_identity_verification',
	'complete_aml_review',
	'complete_pep_questionnaire',
	'account_blocked',
];

export function toActionFlags(input: ComplianceInput): ActionFlag[] {
	const flags = new Set<ActionFlag>();

	if (input.kycIsOutdated || input.amlKycRevalidationState === 'BLOCKED') {
		flags.add('renew_identity_verification');
	}
	if (input.amlLegalReviewRequested || input.amlLegalReviewOutdated) {
		flags.add('complete_aml_review');
	}
	if (input.pepAssetsOriginQuestionnaireRequired || input.pepBankIdRequired) {
		flags.add('complete_pep_questionnaire');
	}
	if (input.customerBlockingReasons && input.customerBlockingReasons.length > 0) {
		flags.add('account_blocked');
	}

	return Array.from(flags);
}
